export const darkTheme = {
    bg:"#1C1C27",
    primary:"#854CE6",
    textPrimary:"#F2F3F4",
    textSecondary:"#b1b2b3",
    card:"#171721",
    cardLight: '#191924',
    button:"#854CE6",
    white:"#FFFFFF",
    filterImageInvert: "invert(0)",
    filterImage: "invert(1)"
}

export const lightTheme = {
    bg:"#FFFFFF",
    primary:"#be1adb",
    textPrimary:"#111111",
    textSecondary:"#48494a",
    card:"#FFFFFF",
    cardLight: "#F2F3F4",
    button:"#5c5b5b",
    white:"#FFFFFF",
    filterImageInvert: "invert(1)",
    filterImage: "invert(0)"
}